import {
  Component,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { SeoPage } from '@domgen/dgx-fe-seo';

import { AsyncPipe, LowerCasePipe, NgIf } from '@angular/common';
import { LoadingOverlayComponent } from '@domgen/dgx-fe-components/loading';
import { PictureComponent } from '@domgen/dgx-fe-components/media';
import {
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import {
  CheckoutEventError,
  CheckoutEventFailure,
  CheckoutEventSuccess,
  CheckoutEventTimeout,
} from '@us-registration/util-models';
import { translation } from '../i18n/translation.constant';
import { CheckoutComponentService } from '../services/checkout-component/checkout-component.service';

interface CheckoutResponseEvent extends Event {
  detail:
    | CheckoutEventSuccess
    | CheckoutEventFailure
    | CheckoutEventTimeout
    | CheckoutEventError;
}

@Component({
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  providers: [
    CheckoutComponentService,
    provideTranslationDictionaryMapping(translation),
  ],
  imports: [
    AsyncPipe,
    TranslatePipe,
    NgIf,
    PictureComponent,
    LoadingOverlayComponent,
    LowerCasePipe,
  ],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
@SeoPage()
export class CheckoutComponent implements OnInit {
  @HostListener('window:dngCheckoutSuccess', ['$event'])
  handleCheckoutEventSuccess = (event: CheckoutResponseEvent) =>
    this.cs.checkoutSuccess(event.detail as CheckoutEventSuccess);

  @HostListener('window:dngCheckoutFailure', ['$event'])
  handleCheckoutEventFailure = (event: CheckoutResponseEvent) =>
    this.cs.checkoutFailure(event.detail as CheckoutEventFailure);

  @HostListener('window:dngCheckoutTimeout', ['$event'])
  handleCheckoutEventTimeout = () => this.cs.checkoutTimeout();

  @HostListener('window:dngCheckoutError', ['$event'])
  handleCheckoutEventError = () => this.cs.checkoutError();

  constructor(readonly cs: CheckoutComponentService) {}

  ngOnInit(): void {
    this.cs.getCheckout();
  }
}
